import { enableProdMode, importProvidersFrom } from '@angular/core';
import { environment } from './environments/environment';

import { providePrimeNG } from 'primeng/config';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { TreeTableModule } from 'primeng/treetable';
import { HisCoreModule } from 'hisng';
import { AppComponent } from './app/app.component';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { ROUTES } from 'app/app.routes';

import aura from '@primeng/themes/aura';

if ( environment.production ) {
    enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(
            BrowserModule,
            FormsModule,
            HttpClientModule,
            TreeTableModule,
            HisCoreModule
        ),
        provideAnimations(),
        providePrimeNG({
            theme: {
                preset: aura
            }
        }),
        provideRouter(
            ROUTES,
            withInMemoryScrolling({ scrollPositionRestoration: 'enabled' })
        )
    ]
});
